import styled from 'styled-components'

export const Container = styled.div`
background-color: white;
padding: 1rem;
height: 100%;

@media(max-width: 480px){
  padding: 1rem .75rem 2rem .75rem;
}
`

export const HeaderContainer = styled.div`
display: flex;
justify-content: space-between;
padding: 1.5rem 2rem 1rem 2rem;
background-color: white;
align-items: center;
gap: 1rem;

img{
  max-height: 10rem;
  max-width: 10rem;
  object-fit: scale-down;
}

@media(max-width: 480px){
  padding: 1rem 1rem .75rem 1rem;

  h1{
    font-size: 1.375rem;
    line-height: 1.75rem;
  }

  img{
    max-height: 3rem;
    max-width: 6rem;
  }
}
`
